// TabNavigation.jsx
import React from 'react';
import './TabNavigation.css';
import { useTranslation } from 'react-i18next';

const TabNavigation = ({ currentTab, onTabChange, userRole, isTransitioning }) => {
  const { t } = useTranslation();

  const tabs = [
    { name: 'members', label: t('tabNavigation.members') },
    { name: 'communications', label: t('tabNavigation.communications'), adminOnly: true },
    { name: 'settings', label: t('tabNavigation.settings'), adminOnly: true },
    { name: 'users', label: t('tabNavigation.users'), adminOnly: true },
  ];

  return (
    <nav className="tab-navigation" aria-label={t('tabNavigation.ariaLabel')}>
      {tabs.map((tab) => {
        if (tab.adminOnly && userRole !== 'admin') return null;
        return (
          <button
            key={tab.name}
            onClick={() => onTabChange(tab.name)}
            className={currentTab === tab.name ? 'active-tab' : ''}
            disabled={isTransitioning}
            aria-current={currentTab === tab.name ? 'page' : undefined}
          >
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
};

export default TabNavigation;
